import CustomButton from "@Common/CustomButton"
import { Dispatch, SetStateAction, useContext } from "react"
import { useTranslation } from "react-i18next"
import UserCrossRounded from "@assets/svg/UserCrossRounded.svg?react"
import { IoClose } from "react-icons/io5"
import { DeleteUserManagementRecordWrapper } from "./styles"
import { APIS_KEYS, useDeleteTeamMember } from "@services"
import { useQueryClient } from "@tanstack/react-query"
import { ToastMessageContext } from "@context/toast-message-cotnext"
interface IProps {
	setIsDeletePopupOpen: Dispatch<SetStateAction<boolean>>
	selectedRecord:
		| {
				userId: number
				userTypeId: number
		  }
		| undefined
}
export default function DeleteUserManagementRecord({
	setIsDeletePopupOpen,
	selectedRecord,
}: IProps) {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const { showSuccess } = useContext(ToastMessageContext)
	/* ---------------------------------- API'S --------------------------------- */
	const { mutateAsync } = useDeleteTeamMember()
	const deleteRecord = async () => {
		if (!selectedRecord) return
		const response = await mutateAsync(selectedRecord)
		if (response.status === 200) {
			queryClient.invalidateQueries({
				queryKey: [APIS_KEYS.GETALLOWNERUSERS],
			})
			showSuccess(t("UserManagement.deleted_successfully"))
			setIsDeletePopupOpen(false)
		}
	}
	return (
		<DeleteUserManagementRecordWrapper>
			<div className='module'>
				<div
					className='closeSection'
					onClick={() => setIsDeletePopupOpen(false)}
				>
					<IoClose />
				</div>

				<div>
					<div>
						<UserCrossRounded />
					</div>
					<p>{t("UserManagement.are_you_sure_you_want_to_delete_this_user")}</p>
				</div>

				<div>
					<CustomButton
						borderColor='#FAFAFB'
						customBG='#FAFAFB'
						customColor='#5B3FFF'
						label={t("UserManagement.close")}
						customPadding='12px 24px'
						onClick={() => setIsDeletePopupOpen(false)}
						type='button'
					/>

					<CustomButton
						customBG=' #E85B5B17'
						customColor='#E85B5B'
						label={t("UserManagement.delete")}
						borderColor='#E85B5B17'
						customPadding='12px 24px'
						type='button'
						onClick={() => deleteRecord()}
					/>
				</div>
			</div>
		</DeleteUserManagementRecordWrapper>
	)
}
